import React, { useState } from 'react';
import './GameSettings.css';

const GameSettings = ({ onStartGame }) => {
  const [selectedSymbol, setSelectedSymbol] = useState(null);
  const [selectedDifficulty, setSelectedDifficulty] = useState(null);

  const handleStartGame = () => {
    if (selectedSymbol && selectedDifficulty) {
      onStartGame(selectedSymbol, selectedDifficulty);
    }
  };

  return (
    <div className="game-settings">
      <div className="settings-section">
        <h2>Choose Your Symbol</h2>
        <div className="symbol-buttons">
          <button
            className={`symbol-btn ${selectedSymbol === 'X' ? 'active' : ''}`}
            onClick={() => setSelectedSymbol('X')}
          >
            <span className="symbol-display x">X</span>
          </button>
          <button
            className={`symbol-btn ${selectedSymbol === 'O' ? 'active' : ''}`}
            onClick={() => setSelectedSymbol('O')}
          >
            <span className="symbol-display o">O</span>
          </button>
        </div>
      </div>

      <div className="settings-section">
        <h2>Choose Difficulty</h2>
        <div className="difficulty-buttons">
          <button
            className={`difficulty-btn ${selectedDifficulty === 'Easy' ? 'active' : ''}`}
            onClick={() => setSelectedDifficulty('Easy')}
          >
            <div className="difficulty-info">
              <span className="difficulty-name">Easy</span>
              <span className="difficulty-desc">Random moves</span>
            </div>
          </button>
          <button
            className={`difficulty-btn ${selectedDifficulty === 'Hard' ? 'active' : ''}`}
            onClick={() => setSelectedDifficulty('Hard')}
          >
            <div className="difficulty-info">
              <span className="difficulty-name">Hard</span>
              <span className="difficulty-desc">Smart AI</span>
            </div>
          </button>
        </div>
      </div>

      <div className="how-to-play">
        <h3>How to Play</h3>
        <ul>
          <li>Choose X or O as your symbol</li>
          <li>Select your preferred difficulty</li>
          <li>Click on squares to make your move</li>
          <li>Get three in a row to win!</li>
        </ul>
      </div>

      <button
        className={`start-game-btn ${selectedSymbol && selectedDifficulty ? 'ready' : 'disabled'}`}
        onClick={handleStartGame}
        disabled={!selectedSymbol || !selectedDifficulty}
      >
        {selectedSymbol && selectedDifficulty ? 'Start Game' : 'Select Symbol & Difficulty'}
      </button>
    </div>
  );
};

export default GameSettings;